import { createSlice } from "@reduxjs/toolkit";

const getUserFromLocalStorage = () => {
  const userJson = localStorage.getItem("user");
  return userJson ? JSON.parse(userJson) : null;
};

const initialState = {
  isAuthenticated: localStorage.getItem("isAuthenticated") === "true",
  user: getUserFromLocalStorage(),
  role: getUserFromLocalStorage()?.role || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.role = action.payload.role;
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
      state.role = null;
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("user");
    },
  },
});

// Exporting actions generated by createSlice
export const { login, logout } = authSlice.actions;

// Exporting reducer
export default authSlice.reducer;
